import HighlightProducts from '@/components/HighlightProducts'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: HighlightProducts,
		vueInit: null,
	}

	let page = vuewidget(dom, options)
	return page
}
